<script setup>
import { computed } from 'vue'

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
})

const countdown = computed(() => {
  const countdownData = props.item.enrichment.countdown
  return {
    days: countdownData.days,
    daysLabel: countdownData.days === 1 ? 'dag' : 'dagen',
    hours: countdownData.hours.toString().padStart(2, '0'),
    minutes: countdownData.minutes.toString().padStart(2, '0'),
    seconds: countdownData.seconds.toString().padStart(2, '0'),
  }
})
</script>

<template>
  <div
    :style="{
      fontSize: item.properties.position.fontSize + 'px',
    }"
  >
    <div
      :style="{
        left: item.properties.position.xCenter + 'px',
        top: item.properties.position.yTop + 'px',
        width: '4em',
        gap: '.25em',
      }"
      class="absolute text-white font-normal leading-[.5em] text-center grid gap-4 -translate-x-1/2"
      :class="countdown.days > 0 ? 'grid-cols-4 ' : 'grid-cols-3'"
    >
      <div v-if="countdown.days > 0">
        <div class="font-cervo-mono tracking-[-3px]">{{ countdown.days }}</div>
        <div class="font-blackbones text-[0.35em]">{{ countdown.daysLabel }}</div>
      </div>
      <div>
        <div class="font-cervo-mono tracking-[-3px]">{{ countdown.hours }}</div>
        <div class="font-blackbones text-[0.35em]">uur</div>
      </div>
      <div>
        <div class="font-cervo-mono tracking-[-3px]">{{ countdown.minutes }}</div>
        <div class="font-blackbones text-[0.35em]">minuten</div>
      </div>
      <div>
        <div class="font-cervo-mono tracking-[-3px]">{{ countdown.seconds }}</div>
        <div class="font-blackbones text-[0.35em]">seconden</div>
      </div>
    </div>
  </div>
</template>
